'use strict';
/*
* Special Page Modal Window
* @package krobot
* @deps jquery
*/
const $ = jQuery;

const ua = window.navigator.userAgent.toLowerCase();
const isiOS = ua.indexOf( 'iphone' ) > -1 || ua.indexOf( 'ipad' ) > -1 || ( ua.indexOf( 'macintosh' ) > -1 && 'ontouchend' in document );
const body = $( 'body' );
let scrollPosition;

//open modal window
$( '.js-sp-modal a[href^="#"]' ).on( 'click keypress', function() {
	const targetModalElement = $( this ).attr( 'href' );
	const targetModalObj = $( targetModalElement );
	targetModalObj.addClass( 'expanded' );
	if ( isiOS ) {
		scrollPosition = window.pageYOffset;
		body.css( 'position', 'fixed' );
		body.css( 'top', '-' + scrollPosition + 'px' );
		body.addClass( 'off' );
	} else {
		body.addClass( 'off' );
	}
	return false;
} );

//close modal window
$( '.js-sp-modal-close a' ).on( 'click keypress', function() {
	$( '.sp-modal' ).removeClass( 'expanded' );
	if ( isiOS ) {
		body.css( 'position', '' );
		body.css( 'top', '' );
		$( window ).scrollTop( scrollPosition );
		body.removeClass( 'off' );
	} else {
		body.removeClass( 'off' );
	}
	return false;
} );
